import DetailExtendImplementationTime from 'features/SubmitProjectProposal/pages/ExtendImplementationTime/Detail';

import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

function ExtendImplementationTimeDetailPage() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
          backgroundColor: 'white',
        }}
      >
        <DetailExtendImplementationTime />
      </Layout>
    </LayoutProvider>
  );
}

export default ExtendImplementationTimeDetailPage;
